import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Button, Rating, TextareaAutosize, useMediaQuery } from '@mui/material';
import { FC, useState } from 'react';
import {
  Controller,
  FormProvider,
  SubmitHandler,
  useForm,
} from 'react-hook-form';

import { useActions } from '../../../hooks/useActions';
import { useCard } from '../../../hooks/useCard';
import { useReview } from '../../../hooks/useReview';
import { useUser } from '../../../hooks/useUser';
import { IReview } from '../../../store/review/review.interface';

import styles from './ReviewForm.module.sass';

interface IReviewForm {
  handleShowModalForm: () => void;
}

const ReviewForm: FC<IReviewForm> = ({ handleShowModalForm }) => {
  const { setFormSubmitted } = useActions();
  const { addReview } = useActions();
  const { catalog_item } = useCard();
  const { formSubmitted } = useReview();
  const { loggedIn } = useUser();
  const mobileScreen = useMediaQuery('(max-width:900px)');
  const form = useForm<IReview>({
    mode: 'onChange',
  });
  const onSubmit: SubmitHandler<IReview> = (data) => {
    addReview({
      owner_id: catalog_item.id,
      stars: data.stars,
      content: data.content,
      owner_type: 'Catalog::Item',
    });
    if (loggedIn) {
      setFormSubmitted(true);
    }
  };

  return (
    <>
      {formSubmitted ? (
        <></>
      ) : (
        <div className={styles.form}>
          <div className={styles.top}>
            <h1>Отзыв о товаре</h1>
            {mobileScreen && (
              <CloseRoundedIcon
                className={styles.close}
                onClick={handleShowModalForm}
              />
            )}
            <div className={styles.estimate}>
              <h3>Оцените покупку</h3>

              <div className={styles.stars}>
                <Controller
                  control={form.control}
                  name="stars"
                  defaultValue={5}
                  render={({ field: { onChange, value } }) => (
                    <Rating
                      size="large"
                      onChange={onChange}
                      value={Number(value)}
                    />
                  )}
                />
              </div>
            </div>
          </div>
          <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)}>
              <TextareaAutosize
                {...form.register('content')}
                placeholder="Оставьте свой отзыв"
              />
              <div className={styles.bottom}>
                <p>
                  Нажимая кнопку "Отправить", Вы соглашаетесь c условиями
                  {!mobileScreen && <br />}{' '}
                  <span>политики конфиденциальности</span>
                </p>
                <Button
                  variant="orange"
                  className={styles.button}
                  type="submit"
                >
                  Отправить
                </Button>
              </div>
            </form>
          </FormProvider>
        </div>
      )}
    </>
  );
};

export default ReviewForm;
